import { makeVar, useReactiveVar } from "@apollo/client";

export const selectedKeyframeVariable = makeVar<string>("");

export const useSelectedKeyframe = () =>
  useReactiveVar(selectedKeyframeVariable);
